export type FlowType = 'create' | 'edit' | 'detail' | 'duplicate' | 'add-child';

export const RESET_FLOW_TYPES = new Set(['create', 'duplicate', 'add-child']);

export const isResetFlowType = (flowType: FlowType) => RESET_FLOW_TYPES.has(flowType);
